import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import { KeyboardReturnOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import CurrentAccounts from './'
import { isClient, SessionState } from '../../../reducers/auth/session'
import { AppState } from '../../../reducers'
import { fetchCurrentAccounts } from '../../../actions/currentAccount/currentAccountList'
import { roleToURLPrefix } from '../../../App'
import { PERSON } from '../../../models/User'
import CurrentAccount from '../../../models/CurrentAccount'
import { receiptLegalTypes } from '../../GeneralDesc'
import { ClientInformation } from '../../Administrator/Clients/ClientsDetail'
import { fetchClient } from '../../../actions/client/clientDetail'
import { fetchPeople } from '../../../actions/person/personList'
import { fetchProvinces } from '../../../actions/deliveryLocation/provinceList'
import { fetchDeliveryLocations } from '../../../actions/deliveryLocation/deliveryLocationList'


const CurrentAccountClientView: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const { codigo_cliente } = useParams<{ codigo_cliente: string }>()

  const session: SessionState = useSelector((state: AppState) => state.session)
  const currentAccountList = useSelector((state: AppState) => state.currentAccountList)
  const clientDetail = useSelector((state: AppState) => state.clientDetail)
  const personList = useSelector((state: AppState) => state.personList)
  const deliveryLocationList = useSelector((state: AppState) => state.deliveryLocationList)
  const provinceList = useSelector((state: AppState) => state.provinceList)

  useEffect(() => {
    dispatch(fetchCurrentAccounts(`?codigo_cliente=${codigo_cliente}&limit=1000`))
    dispatch(fetchClient(codigo_cliente))
    dispatch(fetchPeople(`?personType=C&byPersonTypeId=${codigo_cliente}`))
    dispatch(fetchProvinces(`?all=true`))
    dispatch(fetchDeliveryLocations(`?codigo_cliente=${codigo_cliente}`))

  }, [dispatch, codigo_cliente])

  const linkToBack = () => {
    const prefix = roleToURLPrefix((session?.roles || []).filter(r => r !== PERSON)[0] ?? '')
    if (history.length > 1) {
      history.goBack()
    } else {
      history.push(`/${prefix}/currentAccountSummary`)
    }
  }

  const linkToCurrentAccountDetail = (currentAccount: CurrentAccount) => {
    if (currentAccount.comprobante.includes('CR')) {
      const match = currentAccount.comprobante.match(/^([A-Z]+)\s+(\d+)-(\d+)$/)
      if (match) {
        const sucursal = match[2]
        const numero = match[3]

        const paramsUrl = !isClient(session)
          ? `${sucursal}&${numero}&${codigo_cliente}`
          : `${sucursal}&${numero}`

        const prefix = roleToURLPrefix((session?.roles || []).filter(r => r !== PERSON)[0] ?? '')
        history.push(`/${prefix}/bouncedReceipts/detail/${paramsUrl}`)
      }
    } else {
      if (receiptLegalTypes.includes(currentAccount.comprobante.charAt(0))) {
        const paramsUrl = !isClient(session)
          ? `${currentAccount.comprobante}&${codigo_cliente}`
          : `${currentAccount.comprobante}`

        const prefix = roleToURLPrefix((session?.roles || []).filter(r => r !== PERSON)[0] ?? '')
        history.push(`/${prefix}/accounts/detail/${paramsUrl}`)
      }
    }
  }

  return (
    <div>
      <ClientInformation client={clientDetail} personList={personList} deliveryLocationList={deliveryLocationList} provinceList={provinceList} />
      <CurrentAccounts
        rows={(currentAccountList.currentAccounts || []).map(s => ({ data: s }))}
        electronicStockRows={(currentAccountList.electronicStock || []).map(s => ({ data: s }))}
        loading={currentAccountList.isFetching}
        fullInfo={true}
        adminInfo={true}
        pagination={undefined}
        codigo_cliente={codigo_cliente}
        showDownloadButton={true}
        fromClientView={true}
        onClickInfo={linkToCurrentAccountDetail}
      />

      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <Button
          color='secondary'
          variant='contained'
          sx={{ textTransform: 'none', margin: '10px' }}
          startIcon={<KeyboardReturnOutlined />}
          onClick={linkToBack}
        >
          {t('back', { ns: 'others' })}
        </Button>
      </Box>
    </div>
  )
}

export default CurrentAccountClientView
